<template>
  <div class="default-info">
    <div class="title">
      {{title}}
    </div>
    <div class="elements"
         v-for="(element,index) in elements"
         :key="index"
    >
      {{element}}
    </div>
  </div>
</template>

<script>
export default {
  name: "default-info",

  props : {
    title : {
      type : String,
      required : true,
    },
    elements : {
      type : Array,
      required : false
    }
  }
}
</script>

<style scoped>

</style>